/* eslint-disable @typescript-eslint/no-duplicate-enum-values */
import {
    EndpointConfiguration as ForgeEndpointConfig,
    Stage as ForgeStage,
} from "@amzn/ads-forge-client";
import {
    EndpointConfiguration as AquilaEndpointConfig,
    Stage as AquilaStage,
} from "@amzn/aquila-service-type-script-client";

import type { AuthSettings } from "../store/auth";

enum BlinkAccounts {
    BETA = "539247460185",
    GAMMA = "761018893826",
    PROD = "727646465055",
}

export const betaNaSettings: AuthSettings = {
    apiEndpoint: "us-east-1.beta.api.cdb.ads.amazon.dev",
    region: "us-east-1",
    stage: "beta",
    cognitoPoolId: "us-east-1:8d9d4f9a-f92b-4533-a9a7-94ac2bd47d6b",
    ppApiEndpoint: "beta.api.publisher-portal.cdb.ads.amazon.dev",
    discoveryApiEndpoint: "jd16lw8pxd.execute-api.us-east-1.amazonaws.com/beta",
    aquilaApiEndpoint: new AquilaEndpointConfig(AquilaStage.BETA),
    forgeApiEndpoint: new ForgeEndpointConfig(ForgeStage.BETA),
    rumAppId: "49eab293-90dc-46ac-a290-4f1af8bcd3e2",
    rumRegion: "us-east-1",
    phoenixRumAppId: "97fda4fd-ddc3-4e99-9711-a75fb45177c2",
    phoenixCognitoPoolId: "us-east-1:003418cf-291b-4377-9cf0-218f7c992d1e",
    aquilaConfig: {
        featureAccess: {
            configId: "FeatureAccess",
            awsAccountId: BlinkAccounts.BETA,
        },
        homePageFeedbackForm: {
            configId: "HomePageFeedbackForm_StormV4",
            awsAccountId: BlinkAccounts.BETA,
        },
        insightDetailFeedbackForm: {
            configId: "InsightDetailFeedbackForm_StormV4",
            awsAccountId: BlinkAccounts.BETA,
        },
        yourInsightsTabReportIssueConfig: {
            configId: "YourInsightsTabReportIssueConfig_V2",
            awsAccountId: BlinkAccounts.BETA,
        },
        allInsightsTabReportIssueConfig: {
            configId: "AllInsightsTabReportIssueConfig_V3",
            awsAccountId: BlinkAccounts.BETA,
        },
        sidePanelReportIssueConfig: {
            configId: "SidePanelReportIssueConfig_V2",
            awsAccountId: BlinkAccounts.BETA,
        },
        createInsightDeckPageReportIssueConfig: {
            configId: "CreateInsightDeckPageReportIssueConfig_V2",
            awsAccountId: BlinkAccounts.BETA,
        },
        generalThumbsFeedbackConfig: {
            configId: "GeneralThumbsFeedbackConfig_StormV4",
            awsAccountId: BlinkAccounts.BETA,
        },
        IHubFeatureRequestConfig: {
            configId: "IHubFeatureRequestConfig",
            awsAccountId: BlinkAccounts.BETA,
        },
    },
    adsApiEndpoint: "https://advertising.integ.amazon.com/a9g-api-gateway",
    g4sApiEndpoint:
        "srd356zqnfvg76xphzfo7kepcm0kofyp.lambda-url.us-east-1.on.aws",
    g4sApiInvocationRoleArn:
        "arn:aws:iam::975050244018:role/G4SService-APIInvocationRole-beta",
    plmApiEndpoint: "8ezadyz07g.execute-api.us-east-1.amazonaws.com/beta",
    blinkApiEndpoint: "beta.iad.api.blink.ads.amazon.dev",
    blinkAwsAccountId: BlinkAccounts.BETA,
    g4sServiceEndpoint: "gjql8u4rth.execute-api.us-east-1.amazonaws.com/beta",
    g4sServiceInvocationRoleArn:
        "arn:aws:iam::975050244018:role/IHub-ClientAssumeRole-beta-us-east-1",
    seleneApiEndpoint: "beta.iad.api.selene.ads.amazon.dev",
    magnetoApiEndpoint: "beta.iad.magneto.ads.amazon.dev",
    magnetoPoolId: "us-east-1:8fc517ea-e849-4a0c-a94f-ed8b7578ae6c",
};

export const gammaNaSettings: AuthSettings = {
    apiEndpoint: "us-east-1.gamma.api.cdb.ads.amazon.dev",
    region: "us-east-1",
    stage: "gamma",
    cognitoPoolId: "us-east-1:7d1152c1-855b-46ee-bbec-7da316f5c665",
    ppApiEndpoint: "prod.api.publisher-portal.cdb.ads.amazon.dev",
    discoveryApiEndpoint:
        "l0oe21jmd1.execute-api.us-east-1.amazonaws.com/gamma",
    aquilaApiEndpoint: new AquilaEndpointConfig(AquilaStage.GAMMA),
    forgeApiEndpoint: new ForgeEndpointConfig(ForgeStage.GAMMA),
    rumAppId: "87db38c5-708d-414d-9421-d5b4bb09a26b",
    rumRegion: "us-east-1",
    phoenixRumAppId: "6b0b07be-7b0c-4366-9e16-b646e2f496c6",
    phoenixCognitoPoolId: "us-east-1:4f24817a-5424-4988-bdb4-36304eccd4b3",
    aquilaConfig: {
        featureAccess: {
            configId: "FeatureAccess",
            awsAccountId: BlinkAccounts.GAMMA,
        },
        homePageFeedbackForm: {
            configId: "HomePageFeedbackForm_StormV4",
            awsAccountId: BlinkAccounts.GAMMA,
        },
        insightDetailFeedbackForm: {
            configId: "InsightDetailFeedbackForm_StormV4",
            awsAccountId: BlinkAccounts.GAMMA,
        },
        yourInsightsTabReportIssueConfig: {
            configId: "YourInsightsTabReportIssueConfig_V2",
            awsAccountId: BlinkAccounts.GAMMA,
        },
        allInsightsTabReportIssueConfig: {
            configId: "AllInsightsTabReportIssueConfig_V3",
            awsAccountId: BlinkAccounts.GAMMA,
        },
        sidePanelReportIssueConfig: {
            configId: "SidePanelReportIssueConfig_V2",
            awsAccountId: BlinkAccounts.GAMMA,
        },
        createInsightDeckPageReportIssueConfig: {
            configId: "CreateInsightDeckPageReportIssueConfig_V2",
            awsAccountId: BlinkAccounts.GAMMA,
        },
        generalThumbsFeedbackConfig: {
            configId: "GeneralThumbsFeedbackConfig_StormV4",
            awsAccountId: BlinkAccounts.GAMMA,
        },
        IHubFeatureRequestConfig: {
            configId: "IHubFeatureRequestConfig",
            awsAccountId: BlinkAccounts.GAMMA,
        },
    },
    adsApiEndpoint: "https://advertising-preprod.amazon.com/a9g-api-gateway",
    g4sApiEndpoint:
        "tcoen6fpnvlvycn54w4spe4oay0xnacq.lambda-url.us-east-1.on.aws",
    g4sApiInvocationRoleArn:
        "arn:aws:iam::905418160082:role/G4SService-APIInvocationRole-gamma",
    plmApiEndpoint: "79pqn47d09.execute-api.us-east-1.amazonaws.com/gamma",
    blinkApiEndpoint: "gamma.iad.api.blink.ads.amazon.dev",
    blinkAwsAccountId: BlinkAccounts.GAMMA,
    g4sServiceEndpoint: "ihfyhzbf6f.execute-api.us-east-1.amazonaws.com/gamma",
    g4sServiceInvocationRoleArn:
        "arn:aws:iam::905418160082:role/IHub-ClientAssumeRole-gamma-us-east-1",
    seleneApiEndpoint: "gamma.iad.api.selene.ads.amazon.dev",
    magnetoApiEndpoint: "gamma.iad.magneto.ads.amazon.dev",
    magnetoPoolId: "us-east-1:5771c819-0ca0-492f-98e6-a4f0694b23b9",
};

export const prodNaSettings: AuthSettings = {
    apiEndpoint: "us-east-1.prod.api.cdb.ads.amazon.dev",
    region: "us-east-1",
    stage: "prod",
    cognitoPoolId: "us-east-1:4ade7867-c628-4145-8567-cdae8b4adb94",
    ppApiEndpoint: "prod.api.publisher-portal.cdb.ads.amazon.dev",
    discoveryApiEndpoint: "dp1nagv5t6.execute-api.us-east-1.amazonaws.com/prod",
    aquilaApiEndpoint: new AquilaEndpointConfig(AquilaStage.PROD),
    forgeApiEndpoint: new ForgeEndpointConfig(ForgeStage.PROD),
    rumAppId: "780aa7af-e53c-47c6-a826-7cccc42061df",
    rumRegion: "us-east-1",
    phoenixRumAppId: "3e913ed0-7e51-4503-9ac4-e75028ce74a0",
    phoenixCognitoPoolId: "us-east-1:583c6514-75e0-45f2-8c19-5702e09a53c1",
    aquilaConfig: {
        featureAccess: {
            configId: "FeatureAccess",
            awsAccountId: BlinkAccounts.PROD,
        },
        homePageFeedbackForm: {
            configId: "HomePageFeedbackForm_StormV4",
            awsAccountId: BlinkAccounts.PROD,
        },
        insightDetailFeedbackForm: {
            configId: "InsightDetailFeedbackForm_StormV4",
            awsAccountId: BlinkAccounts.PROD,
        },
        yourInsightsTabReportIssueConfig: {
            configId: "YourInsightsTabReportIssueConfig_V2",
            awsAccountId: BlinkAccounts.PROD,
        },
        allInsightsTabReportIssueConfig: {
            configId: "AllInsightsTabReportIssueConfig_V3",
            awsAccountId: BlinkAccounts.PROD,
        },
        sidePanelReportIssueConfig: {
            configId: "SidePanelReportIssueConfig_V2",
            awsAccountId: BlinkAccounts.PROD,
        },
        createInsightDeckPageReportIssueConfig: {
            configId: "CreateInsightDeckPageReportIssueConfig_V2",
            awsAccountId: BlinkAccounts.PROD,
        },
        generalThumbsFeedbackConfig: {
            configId: "GeneralThumbsFeedbackConfig_StormV4",
            awsAccountId: BlinkAccounts.PROD,
        },
        IHubFeatureRequestConfig: {
            configId: "IHubFeatureRequestConfig",
            awsAccountId: BlinkAccounts.PROD,
        },
    },
    adsApiEndpoint: "https://advertising.amazon.com/a9g-api-gateway",
    g4sApiEndpoint:
        "5pw2wy4mhh4nr7k5vk6lqn75pa0jcsgi.lambda-url.us-east-1.on.aws",
    g4sApiInvocationRoleArn:
        "arn:aws:iam::891377156801:role/G4SService-APIInvocationRole-prod",
    plmApiEndpoint: "hbp0h5kw2j.execute-api.us-east-1.amazonaws.com/prod",
    blinkApiEndpoint: "prod.iad.api.blink.ads.amazon.dev",
    blinkAwsAccountId: BlinkAccounts.PROD,
    g4sServiceEndpoint: "06rdlqa6l4.execute-api.us-east-1.amazonaws.com/prod",
    g4sServiceInvocationRoleArn:
        "arn:aws:iam::891377156801:role/IHub-ClientAssumeRole-prod-us-east-1",
    seleneApiEndpoint: "prod.iad.api.selene.ads.amazon.dev",
    magnetoApiEndpoint: "prod.iad.magneto.ads.amazon.dev",
    magnetoPoolId: "us-east-1:39024152-800c-4f0b-8c2e-aceb2cf64526",
};

// Deprecate
const hexConfigs = new Map<string, AuthSettings>([
    ["corp.ihws-d16ginsig-b56ba2oqd1.iad.beta.hex.a2z.com", betaNaSettings],
    ["corp.ihws-d16ginsig-gfilisob5q.iad.gamma.hex.a2z.com", gammaNaSettings],
    ["corp.ihws-d16ginsig-omer1490ru.iad.prod.hex.a2z.com", prodNaSettings],
]);

// Deprecate
export const ihubConfigs = new Map<string, AuthSettings>([
    ["us-east-1.beta.insights-hub.cdb.ads.amazon.dev", betaNaSettings],
    ["us-east-1.gamma.insights-hub.cdb.ads.amazon.dev", gammaNaSettings],
    ["eu-west-1.gamma.insights-hub.cdb.ads.amazon.dev", gammaNaSettings],
    ["us-west-2.gamma.insights-hub.cdb.ads.amazon.dev", gammaNaSettings],
    ["us-east-1.prod.insights-hub.cdb.ads.amazon.dev", prodNaSettings],
    ["eu-west-1.prod.insights-hub.cdb.ads.amazon.dev", prodNaSettings],
    ["us-west-2.prod.insights-hub.cdb.ads.amazon.dev", prodNaSettings],
]);

export enum BlinkWebsiteHost {
    "beta" = "beta.iad.horizon.blink.ads.amazon.dev",
    "beta-itl" = "itl.beta.iad.horizon.blink.ads.amazon.dev",
    "beta-uat" = "uat.beta.iad.horizon.blink.ads.amazon.dev",
    "gamma" = "gamma.iad.horizon.blink.ads.amazon.dev",
    "gamma-uat" = "uat.gamma.iad.horizon.blink.ads.amazon.dev",
    "prod" = "prod.iad.horizon.blink.ads.amazon.dev",
    "prod-uat" = "uat.prod.iad.horizon.blink.ads.amazon.dev",
}

export enum PublisherWebsiteHost {
    "beta" = "beta.publisher-portal.cdb.ads.amazon.dev",
    "gamma" = "prod.publisher-portal.cdb.ads.amazon.dev",
    "prod" = "prod.publisher-portal.cdb.ads.amazon.dev",
}

export const blinkConfigs = new Map<string, AuthSettings>([
    [BlinkWebsiteHost.beta, betaNaSettings],
    [BlinkWebsiteHost["beta-itl"], betaNaSettings],
    [BlinkWebsiteHost["beta-uat"], betaNaSettings],
    [BlinkWebsiteHost.gamma, gammaNaSettings],
    [BlinkWebsiteHost["gamma-uat"], gammaNaSettings],
    [BlinkWebsiteHost.prod, prodNaSettings],
    [BlinkWebsiteHost["prod-uat"], prodNaSettings],
]);

// https://code.amazon.com/packages/AACCloudWatchRUMConfig/blobs/mainline/--/configuration/brazil-config/global/AACCloudWatchRUM-Prod-NA.cfg
export const aacProdNaConfigs = new Map<string, AuthSettings>([
    ["advertising.amazon.com", prodNaSettings],
    ["advertising.amazon.ca", prodNaSettings],
    ["advertising.amazon.com.mx", prodNaSettings],
    ["advertising.amazon.com.br", prodNaSettings],
    ["advertising.amazon.cl", prodNaSettings],
    ["advertising.amazon.com.co", prodNaSettings],
]);

// https://code.amazon.com/packages/AACCloudWatchRUMConfig/blobs/mainline/--/configuration/brazil-config/global/AACCloudWatchRUM-Prod-FE.cfg
export const aacProdFeConfigs = new Map<string, AuthSettings>([
    ["advertising-japan.amazon.com", prodNaSettings],
    ["advertising.amazon.co.jp", prodNaSettings],
    ["advertising.amazon.com.au", prodNaSettings],
    ["advertising.amazon.sg", prodNaSettings],
]);

// https://code.amazon.com/packages/AACCloudWatchRUMConfig/blobs/mainline/--/configuration/brazil-config/global/AACCloudWatchRUM-Prod-EU.cfg
export const aacProdEuConfigs = new Map<string, AuthSettings>([
    ["advertising.amazon.co.uk", prodNaSettings],
    ["advertising.amazon.de", prodNaSettings],
    ["advertising.amazon.es", prodNaSettings],
    ["advertising.amazon.fr", prodNaSettings],
    ["advertising.amazon.it", prodNaSettings],
    ["advertising.amazon.nl", prodNaSettings],
    ["advertising.amazon.com.be", prodNaSettings],
    ["advertising.amazon.pl", prodNaSettings],
    ["advertising.amazon.sa", prodNaSettings],
    ["advertising.amazon.se", prodNaSettings],
    ["advertising.amazon.com.tr", prodNaSettings],
    ["advertising.amazon.eg", prodNaSettings],
    ["advertising.amazon.in", prodNaSettings],
    ["advertising.amazon.ae", prodNaSettings],
    ["advertising.amazon.com.ng", prodNaSettings],
    ["advertising.amazon.co.za", prodNaSettings],
]);

export const stageRegionAuthConfig = new Map<string, AuthSettings>([
    // https://code.amazon.com/packages/AACCloudWatchRUMConfig/blobs/mainline/--/configuration/brazil-config/global/AACCloudWatchRUM-Beta.cfg
    ["advertising.integ.amazon.com", betaNaSettings],
    // https://code.amazon.com/packages/AACCloudWatchRUMConfig/blobs/mainline/--/configuration/brazil-config/global/AACCloudWatchRUM-Gamma-NA.cfg
    ["advertising-preprod.amazon.com", gammaNaSettings],
    // https://code.amazon.com/packages/AACCloudWatchRUMConfig/blobs/mainline/--/configuration/brazil-config/global/AACCloudWatchRUM-Gamma-FE.cfg
    ["advertising-jp-preprod-pdx.pdx.proxy.amazon.com", gammaNaSettings],
    // https://code.amazon.com/packages/AACCloudWatchRUMConfig/blobs/mainline/--/configuration/brazil-config/global/AACCloudWatchRUM-Gamma-EU.cfg
    ["advertising-uk-preprod.amazon.com", gammaNaSettings],
    ...aacProdNaConfigs,
    ...aacProdFeConfigs,
    ...aacProdEuConfigs,
    ...ihubConfigs,
    ...blinkConfigs,
    ...hexConfigs,
]);
